import React, { useState } from 'react'
import { imageGallery } from '../../constants';

function ImageGallery() {
  const [current, setCurrent] = useState(0);

  function nextSlide() {
    setCurrent(current === imageGallery.length - 1 ? 0 : current + 1);
  }

  function prevSlide() {
    setCurrent(current === 0 ? imageGallery.length - 1 : current - 1);
  }
  return (
    <section id='gallery' className='background-gradient'>
      <div className="container text-center">
        <h2>Galeri Kami</h2>
        <div className="slider mt-5">
          <div className="left-arrow" onClick={prevSlide}>
            ⮕
          </div>
          <div className="right-arrow" onClick={nextSlide}>
            ⮕
          </div>
          {imageGallery.map(
            (image, index) =>
              current === index && (
                <div key={image} className="slide">
                  <img src={image} alt="images" className='imageGallery rounded-4'/>
                </div>
              )
          )}
        </div>
      </div>
    </section>
  )
}

export default ImageGallery